import { motion } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useState,
} from "react";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalLancarCTEStatus from "../../../components/ModalLancarCTEStatus/ModalLancarCTEStatus.tsx";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2.js";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import TabelaRedux from "../../../contexts/Tabela.js";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import { getAguardaCTE } from "../../../services/ModuloGerenciador/Embarque.js";
import { getStatus } from "../../../services/ModuloGerenciador/Status.js";
import "./AguardaCTE.css";

function AguardaCTE() {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const [values, setValues] = useState([]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const [loading, setLoading] = useState(true);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [dadosTabela, setDadosTabela] = useState([]);

	const [dadosRelatorio, setDadosRelatorio] = useState([]);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const buscarAguardandoCte = useCallback(async () => {
		if (!profile) return;
		try {
			const result = await getAguardaCTE(profile?.token);
			setDadosTabela(result?.data);
			setTimeout(() => {
				setLoading(false);
			}, 1000);
			setTabelaRedux({});
		} catch (error) {
			if (error?.response?.data?.length > 200) {
				setTextoErro(
					"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
				);
			} else {
				setTextoErro(error?.response?.data);
			}
			setOpenToastErro(true);
		}
	}, [profile]);

	useEffect(() => {
		if (!profile) return;
		let interval = null;

		const fetchData = () => {
			buscarAguardandoCte();
			buscarStatus();
		};

		fetchData();

		interval = setInterval(fetchData, 30000);

		return () => {
			if (interval) {
				clearInterval(interval);
			}
		};
	}, [profile]);

	useEffect(() => {
		if (!profile) return;
		setSemAutorizacao(!hasRegra("Aguardando CTE"));
		buscarAguardandoCte();
		buscarStatus();
	}, [profile]);

	const dadosRelatorioCSV = [];
	const formatarNumero = (numero) => {
		return numero.toLocaleString("pt-BR", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	};
	const dadosFormatados = {};

	for (const key in dadosRelatorio) {
		if (dadosRelatorio.hasOwnProperty(key)) {
			dadosFormatados[key] = formatarNumero(dadosRelatorio[key]);
		}
	}
	dadosRelatorioCSV.push(dadosFormatados);

	const [selecioneOpen, setSelecioneOpen] = useState(false);

	useEffect(() => {
		if (selecioneOpen === true) {
			setTimeout(() => {
				setSelecioneOpen(false);
			}, 1000);
		}
	}, [selecioneOpen]);

	const [openStatus, setOpenStatus] = useState(false);

	const handleCloseStatus = () => {
		setOpenStatus(false);
	};

	const onSuccessLancarCTEStatus = useCallback(() => {
		setTextoSucesso("CTE e Status Definido com Sucesso!");
		setOpenToastSucesso(true);
		buscarAguardandoCte();
	}, [buscarAguardandoCte]);

	const onErrorLancarCTEStatus = useCallback((error) => {
		if (typeof error?.response?.data === "string") {
			setTextoErro(error.response.data);
		} else if (typeof error === "string") {
			setTextoErro(error);
		} else {
			setTextoErro(
				"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
			);
		}
		setOpenToastErro(true);
	}, []);

	const [listaStatus, setListaStatus] = useState([]);

	const buscarStatus = async () => {
		try {
			const result = await getStatus(profile?.token);
			setLoading(true);
			setListaStatus(result?.data);
			setLoading(false);
			setTabelaRedux({});
		} catch (error) {
			if (typeof error.response.data === "string") {
				setTextoErro(error.response.data);
			} else {
				setTextoErro(
					"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
				);
			}
			setOpenToastErro(true);
		}
	};

	const isLoading = useMemo(() => {
		return loading || !profile || !dadosTabela;
	}, [loading, profile, dadosTabela]);

	if (semAutorizacao) {
		<MotionSemAutorizacao />;
	}

	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
			<NavbarV3 title="Aguardando CTE" selecionado="Aguardando CTE" />
			{!isLoading ? (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					<div className="aguardaCTEs">
						<TabelaV2
							classeSelecionado="idEmbarque"
							nomeClasse1="outer-wrapper"
							nomeClasse2="table-wrapper-v2"
							colunas={tabelaEmpresa.Embarque}
							dados={dadosTabela}
							nome="embarque"
							nomeTable="Embarque"
						/>
						<div
							className="container-botoes-emb"
							style={{ justifyContent: "center" }}
						>
							<div className="flex-row">
								<div className="hover-emb">
									{selecioneOpen && (
										<div className="config-dropdown-none">
											<p>Selecione Uma Coluna</p>
										</div>
									)}
									<CustomButtonV2
										classCss="custom-button-user"
										classText="button-texto-user"
										titulo="Lançar CTE"
										cor="#FFFFFF"
										valor={values}
										onClick={() => {
											if (tabelaRedux.colunaSelecionada) {
												setOpenStatus(true);
												handleCloseToastErro();
												handleCloseToastSucesso();
											} else {
												setSelecioneOpen(!selecioneOpen);
											}
										}}
									/>
								</div>
							</div>
						</div>
					</div>
					<div>
						<ToastSucesso
							texto={textoSucesso}
							open={openToastSucesso}
							onClose={handleCloseToastSucesso}
						/>
						<ToastErro
							texto={textoErro}
							open={openToastErro}
							onClose={handleCloseToastErro}
						/>
						<ModalLancarCTEStatus
							titulo="Lançar CTE e Status"
							tituloConfirmar="OK"
							open={openStatus}
							onClose={handleCloseStatus}
							listaStatus={listaStatus}
							onSuccess={onSuccessLancarCTEStatus}
							onError={onErrorLancarCTEStatus}
						/>
					</div>
				</motion.div>
			) : (
				<LoadingComponent />
			)}
		</motion.div>
	);
}

export default AguardaCTE;
